import React, { PureComponent } from 'react';
import { withRouter, matchPath } from 'react-router';
import PropTypes from 'prop-types';
import { Tabs, Tab, TabsContainer } from 'react-md';
import { injectIntl, intlShape } from 'react-intl';
import qs from 'qs';
import { findIndex } from 'lodash/array';

import Calendar from '../Calendar';
import Contested from '../Contested';
import Stats from '../Stats';
import FollowUp from '../FollowUp';

import { invokeBackendApi } from '../../libs/awsLib';

import JourneyDialog from '../Journey';

import { handleFetchErrors } from '../../utils/errorHandler';
import ErrorDisplay from '../ErrorDisplay';

export default withRouter(injectIntl(class DriverTabs extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    location: PropTypes.object.isRequired,
    userAttributes: PropTypes.shape({
      isPsy: PropTypes.bool.isRequired,
    }).isRequired,
  };
  constructor(props) {
    super(props);
    const { userAttributes: { isPsy }, location: { pathname } } = props;
    const showContested = isPsy && matchPath(pathname, { path: '/contested' });
    this.state = {
      isLoading: true,
      events: [],
      segments: [],
      journeys: [],
      view: 'month',
      activeTabIndex: showContested ? 2 : 0,
      journeyIndex: undefined,
    };
  }

  componentDidMount() {
    this.loadSegments();
    this.loadJourneys();
  }
  onView = (view) => {
    this.setState({ view });
  }

  journeys = () => {
    const { location: { search } } = this.props;
    const { driver } = qs.parse(search.replace('?', ''));
    const path = driver ? `/drivers/${driver}/journeys` : '/journeys';
    return invokeBackendApi({ path });
  }

  loadJourneys = () => {
    this.journeys()
      .then(events => this.setState({
        isLoading: false,
        events,
        journeys: events.filter(e => !e.plugged && !e.unplugged),
      }))
      .catch(e => handleFetchErrors(e, this));
  }

  segmentsByDriver = () => {
    const { location: { search } } = this.props;
    const { driver } = qs.parse(search.replace('?', ''));
    const path = driver ? `/drivers/${driver}/errors` : '/errors';
    return invokeBackendApi({ path });
  }

  loadSegments = () => {
    this.segmentsByDriver()
      .then(segments => this.setState({ isLoading: false, segments }))
      .catch(e => handleFetchErrors(e, this));
  }

  handleSelectEvent = (event) => {
    const { journeys } = this.state;
    const { plugged, unplugged } = event;
    if (plugged || unplugged) return;
    this.setState({ journeyIndex: journeys.indexOf(event) });
  };
  handleClickContested = (segment) => {
    const { journeys } = this.state;
    this.setState({ journeyIndex: findIndex(journeys, j => j.journeyId === segment.journeyId) });
  }

  handleOnCalendarTabClick = () => {
    this.setState({ view: 'month' });
  }
  handleTabChange = activeTabIndex => this.setState({ activeTabIndex });


  render() {
    const { intl, userAttributes, userAttributes: { isPsy } } = this.props;
    const {
      events, segments, journeys, journeyIndex, isLoading, view, error, activeTabIndex,
    } = this.state;

    const calendarTab = (
      <Tab
        key="calendarTab"
        label={intl.formatMessage({ id: 'driverActions.tabs.calendar' })}
        onClick={this.handleOnCalendarTabClick}
      >
        <Calendar
          events={events}
          handleSelectEvent={this.handleSelectEvent}
          view={view}
          onView={this.onView}
        />
      </Tab>
    );
    const statsTab = (
      <Tab
        key="statsTab"
        label={intl.formatMessage({ id: 'driverActions.tabs.stats' })}
      >
        <Stats journeys={journeys} />
      </Tab>
    );
    const contestedTab = (
      <Tab
        key="contestedTab"
        label={intl.formatMessage({ id: 'driverActions.tabs.errorManagement' })}
      >
        <Contested
          userAttributes={userAttributes}
          segmentsByDriver={segments}
          handleOnclick={this.handleClickContested}
        />
      </Tab>
    );
    const followUpTab = (
      <Tab
        key="followUpTab"
        label={intl.formatMessage({ id: 'driverActions.tabs.followUp' })}
      >
        <FollowUp userAttributes={userAttributes} />
      </Tab>
    );

    const displayedTabs = [];

    displayedTabs.push(calendarTab);
    if (isPsy) displayedTabs.push(statsTab);
    displayedTabs.push(contestedTab);
    displayedTabs.push(followUpTab);

    return (
      error ? <ErrorDisplay error={error} /> :
        !isLoading &&
        <div>
          <TabsContainer
            style={{ backgroundColor: '#fff' }}
            activeTabIndex={activeTabIndex}
            onTabChange={this.handleTabChange}
          >
            <Tabs
              tabId="drivers-tabs"
            >
              {displayedTabs}
            </Tabs>
          </TabsContainer>
          <JourneyDialog
            journeys={journeys}
            initialJourneyIndex={journeyIndex}
            onHide={() => this.setState({ journeyIndex: undefined })}
            userAttributes={userAttributes}
          />
        </div>
    );
  }
}));



// WEBPACK FOOTER //
// ./src/components/DriverTabs/index.js